import { useMemo } from "react";
import { useTable } from "react-table";
import { formatNumberWithCommas } from "../../../../helpers";

export const useJournalLineTable = ({ journalEntryDetails }) => {
  const columns = useMemo(
    () => [
      {
        Header: "REFERENCE",
        accessor: "reference",
        Cell: ({ cell: { value }, row }) => value,
      },
      {
        Header: "DESCRIPTION",
        accessor: "description",
        Cell: ({ cell: { value }, row }) => value,
      },
      {
        Header: "ACCOUNT",
        accessor: "chart_account",
        Cell: ({ cell: { value }, row }) => value?.account_label || "",
      },
      {
        Header: `DEBIT (${journalEntryDetails?.currency_code})`,
        accessor: "debit_amount",
        Cell: ({ cell: { value }, row }) =>
          value ? formatNumberWithCommas(value) : "",
      },
      {
        Header: `CREDIT (${journalEntryDetails?.currency_code})`,
        accessor: "credit_amount",
        Cell: ({ cell: { value }, row }) =>
          value ? formatNumberWithCommas(value) : "",
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [journalEntryDetails?.line_items],
  );

  const instance = useTable({
    columns,
    data: journalEntryDetails?.line_items || [],
  });

  return {
    instance,
  };
};
export default useJournalLineTable;
